module.exports = __webpack_public_path__ + "static/media/Dysmate-Y_compressed.0f0747cf.pdf";